import React, { useRef, useState, useEffect } from "react";
import KeyboardReact from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";

const Keyboard = ({ onChange, type = "text", maxLen = 0, value }) => {
  const [layout, setLayout] = useState("default");
  const keyboard = useRef();

  //v pripade ze prijde do value prazdna hodnota tak vynuluj i zasobnik pravdepodobne jde o load nebo clear all btn na input
  if (value === "") {
    keyboard?.current?.setInput(value);
    //console.log("clear all", value);
  }

  useEffect(() => {
    //preplnit pro editaci az po nacteni stranky kvuly ref
    if (value) {
      keyboard?.current?.setInput(value);
      //console.log(keyboard, keyboard?.current, value);
    }
  }, []);

  const csLayoutText = {
    default: [
      "\u011B \u0161 \u010D \u0159 \u017E \u00FD \u00E1 \u00ED \u00E9",
      "q w e r t y u i o p",
      "a s d f g h j k l",
      "{shift} z x c v b n m {backspace}",
    ],
    shift: ["\u011a \u0160 \u010C \u0158 \u017D \u00DD \u00C1 \u00CD \u00C9", "Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {backspace}"],
  };

  const csLayoutCapsText = {
    default: [
      "\u011a \u0160 \u010C \u0158 \u017D \u00DD \u00C1 \u00CD \u00C9 \u00DA \u016E \u0164 \u0147 \u010E \u00D3",
      "Q W E R T Y U I O P",
      "A S D F G H J K L",
      "§ Z X C V B N M §",
      "§ {space} {backspace}",
    ],
  };

  /*vytvoreni neklikatelneho a neviditelneho btn pomoci znaku § */
  const nubmerLayout = {
    default: ["1 2 3", "4 5 6", "7 8 9", "§ 0 {backspace}"],
  };

  const display = {
    "{numbers}": "123",
    "{ent}": "return",
    "{escape}": "esc ⎋",
    "{tab}": "tab ⇥",
    "{backspace}": "⌫ backspace",
    "{capslock}": "caps lock ⇪",
    "{shift}": "  ⇧",
    "{controlleft}": "ctrl ⌃",
    "{controlright}": "ctrl ⌃",
    "{altleft}": "alt ⌥",
    "{altright}": "alt ⌥",
    "{metaleft}": "cmd ⌘",
    "{metaright}": "cmd ⌘",
    "{abc}": "ABC",
    "{space}": "MEZERA",
  };

  const displayNumeric = {
    "{numbers}": "123",
    "{ent}": "return",
    "{escape}": "esc ⎋",
    "{tab}": "tab ⇥",
    "{backspace}": "⌫",
    "{capslock}": "caps lock ⇪",
    "{shift}": "  ⇧",
    "{controlleft}": "ctrl ⌃",
    "{controlright}": "ctrl ⌃",
    "{altleft}": "alt ⌥",
    "{altright}": "alt ⌥",
    "{metaleft}": "cmd ⌘",
    "{metaright}": "cmd ⌘",
    "{abc}": "ABC",
    "{space}": "MEZERA",
  };

  let selectedLayout;
  let selectedDisplay;
  switch (type) {
    case "number":
      selectedLayout = nubmerLayout;
      selectedDisplay = displayNumeric;
      break;
    case "text":
      selectedLayout = csLayoutCapsText;
      selectedDisplay = display;
      break;
    case "hex":
      selectedLayout = csLayoutCapsText;
      selectedDisplay = display;
      break;
  }

  const theme = type === "number" ? "hg-theme-default hg-layout-default numeric-theme" : "hg-theme-default";

  function handleInput(e) {
    //console.log("handleInput", e);
    // const input = event.target.value;
    // const input = e;
    //setInput(input);
    onChange(e);

    //orezavat z keyboard.current.input to co ma odchytit maska
    if (maxLen > 0 && e?.length > maxLen) {
      keyboard.current.setInput(e.substring(0, maxLen));
    } else {
      keyboard.current.setInput(e);
    }
  }

  //   useEffect(() => {
  //     console.log(value);

  //keyboard.current.setInput("8103142377");
  //   }, []);

  function onKeyPress(button) {
    //console.log("onKeyPress", button);
    if (button === "{shift}" || button === "{lock}") handleShift();
  }

  function handleShift() {
    //console.log("handleShift");
    const newLayoutName = layout === "default" ? "shift" : "default";
    setLayout(newLayoutName);
    //console.log(newLayoutName);
  }

  return (
    <KeyboardReact
      className="numeric-theme"
      onChange={(e) => handleInput(e)}
      onKeyPress={(e) => onKeyPress(e)}
      keyboardRef={(r) => (keyboard.current = r)}
      layoutName={layout}
      layout={selectedLayout}
      display={selectedDisplay}
      theme={theme}
    />
  );
};

export default Keyboard;
